module.exports = __webpack_public_path__ + "media/src/neighbourhood_map/images/ligne18-4f387714187e1edb6c7aab1d43856a44.png";